import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import "./SuccessModal.css";
import { CheckCircle, X } from "lucide-react";

interface SuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  message: string;
}

const SuccessModal: React.FC<SuccessModalProps> = ({
  isOpen,
  onClose,
  title = "Success!",
  message,
}) => {
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    if (isOpen) {
      document.addEventListener("keydown", handleEsc);
      if (modalRef.current) modalRef.current.focus();
    }
    return () => document.removeEventListener("keydown", handleEsc);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div
      className="success-modal-overlay"
      tabIndex={-1}
      aria-modal="true"
      role="dialog"
    >
      <div className="success-modal-content" ref={modalRef}>
        <button className="success-modal-close" onClick={onClose} title="Close">
          <X className="w-5 h-5" aria-label="Close modal" />
        </button>
        
        <div className="success-modal-icon">
          <CheckCircle className="w-20 h-20" />
        </div>
        
        <div className="success-modal-body">
          <h2 className="success-modal-title">{title}</h2>
          <p className="success-modal-message">{message}</p>
        </div>
        
        <div className="success-modal-footer">
          <button className="success-modal-button" onClick={onClose}>
            OK
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default SuccessModal;

